// This file is auto-generated

import * as grpcWeb from 'grpc-web';
import { Message } from "google-protobuf";
import { GrpcWebClient, GrpcWebMethodDesc } from '../util/grpc.client';

import * as model from "./report";
import * as dep_1 from "./../tolemac/pub/filter";
import * as dep_2 from "./../google/protobuf/empty";

export class ReportServiceClient<META = grpcWeb.Metadata> extends GrpcWebClient<META> {

    static methodFind = new GrpcWebMethodDesc(
        '/myedvenn.report.ReportService/Find',
        grpcWeb.MethodType.UNARY,
        dep_1.MCriterias,
        model.MReports,
        dep_1.MCriterias.serializeBinary,
        dep_1.MCriterias.deserializeBinary,
        model.MReports.serializeBinary,
        model.MReports.deserializeBinary
    )

    find(request: dep_1.ICriterias, metadata?: META): Promise<model.Reports>;
    find(request: dep_1.ICriterias, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: model.MReports) => void): grpcWeb.ClientReadableStream<model.MReports>;
    find(request: dep_1.ICriterias, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: model.MReports) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + ReportServiceClient.methodFind.getName(),
                request instanceof Message ? request as dep_1.MCriterias : new dep_1.MCriterias(request),
                metadata as grpcWeb.Metadata,
                ReportServiceClient.methodFind as grpcWeb.MethodDescriptor<dep_1.MCriterias, model.MReports>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + ReportServiceClient.methodFind.getName(),
                request instanceof Message ? request as dep_1.MCriterias : new dep_1.MCriterias(request),
                metadata as grpcWeb.Metadata,
                ReportServiceClient.methodFind as grpcWeb.MethodDescriptor<dep_1.MCriterias, model.MReports>
            ).then(x => x.toObject());
    }

    static methodSync = new GrpcWebMethodDesc(
        '/myedvenn.report.ReportService/Sync',
        grpcWeb.MethodType.UNARY,
        dep_2.MEmpty,
        dep_2.MEmpty,
        dep_2.MEmpty.serializeBinary,
        dep_2.MEmpty.deserializeBinary,
        dep_2.MEmpty.serializeBinary,
        dep_2.MEmpty.deserializeBinary
    )

    sync(request: dep_2.IEmpty, metadata?: META): Promise<dep_2.Empty>;
    sync(request: dep_2.IEmpty, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: dep_2.MEmpty) => void): grpcWeb.ClientReadableStream<dep_2.MEmpty>;
    sync(request: dep_2.IEmpty, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: dep_2.MEmpty) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + ReportServiceClient.methodSync.getName(),
                request instanceof Message ? request as dep_2.MEmpty : new dep_2.MEmpty(request),
                metadata as grpcWeb.Metadata,
                ReportServiceClient.methodSync as grpcWeb.MethodDescriptor<dep_2.MEmpty, dep_2.MEmpty>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + ReportServiceClient.methodSync.getName(),
                request instanceof Message ? request as dep_2.MEmpty : new dep_2.MEmpty(request),
                metadata as grpcWeb.Metadata,
                ReportServiceClient.methodSync as grpcWeb.MethodDescriptor<dep_2.MEmpty, dep_2.MEmpty>
            ).then(x => x.toObject());
    }

}

export class LeadServiceClient<META = grpcWeb.Metadata> extends GrpcWebClient<META> {

    static methodFind = new GrpcWebMethodDesc(
        '/myedvenn.report.LeadService/Find',
        grpcWeb.MethodType.UNARY,
        dep_1.MCriterias,
        model.MLeads,
        dep_1.MCriterias.serializeBinary,
        dep_1.MCriterias.deserializeBinary,
        model.MLeads.serializeBinary,
        model.MLeads.deserializeBinary
    )

    find(request: dep_1.ICriterias, metadata?: META): Promise<model.Leads>;
    find(request: dep_1.ICriterias, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: model.MLeads) => void): grpcWeb.ClientReadableStream<model.MLeads>;
    find(request: dep_1.ICriterias, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: model.MLeads) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + LeadServiceClient.methodFind.getName(),
                request instanceof Message ? request as dep_1.MCriterias : new dep_1.MCriterias(request),
                metadata as grpcWeb.Metadata,
                LeadServiceClient.methodFind as grpcWeb.MethodDescriptor<dep_1.MCriterias, model.MLeads>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + LeadServiceClient.methodFind.getName(),
                request instanceof Message ? request as dep_1.MCriterias : new dep_1.MCriterias(request),
                metadata as grpcWeb.Metadata,
                LeadServiceClient.methodFind as grpcWeb.MethodDescriptor<dep_1.MCriterias, model.MLeads>
            ).then(x => x.toObject());
    }

    static methodSync = new GrpcWebMethodDesc(
        '/myedvenn.report.LeadService/Sync',
        grpcWeb.MethodType.UNARY,
        dep_2.MEmpty,
        dep_2.MEmpty,
        dep_2.MEmpty.serializeBinary,
        dep_2.MEmpty.deserializeBinary,
        dep_2.MEmpty.serializeBinary,
        dep_2.MEmpty.deserializeBinary
    )

    sync(request: dep_2.IEmpty, metadata?: META): Promise<dep_2.Empty>;
    sync(request: dep_2.IEmpty, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: dep_2.MEmpty) => void): grpcWeb.ClientReadableStream<dep_2.MEmpty>;
    sync(request: dep_2.IEmpty, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: dep_2.MEmpty) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + LeadServiceClient.methodSync.getName(),
                request instanceof Message ? request as dep_2.MEmpty : new dep_2.MEmpty(request),
                metadata as grpcWeb.Metadata,
                LeadServiceClient.methodSync as grpcWeb.MethodDescriptor<dep_2.MEmpty, dep_2.MEmpty>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + LeadServiceClient.methodSync.getName(),
                request instanceof Message ? request as dep_2.MEmpty : new dep_2.MEmpty(request),
                metadata as grpcWeb.Metadata,
                LeadServiceClient.methodSync as grpcWeb.MethodDescriptor<dep_2.MEmpty, dep_2.MEmpty>
            ).then(x => x.toObject());
    }

}

                        
export default () => {}